import { render, staticRenderFns } from "./AuditoriumWelcome.vue?vue&type=template&id=751ebe5c"
import script from "./AuditoriumWelcome.vue?vue&type=script&lang=js"
export * from "./AuditoriumWelcome.vue?vue&type=script&lang=js"
import style0 from "./AuditoriumWelcome.vue?vue&type=style&index=0&id=751ebe5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports